import { useIntl } from 'react-intl'
import type { IntlShape } from 'react-intl'
import Group from 'components/utils/Group'
import FilterChip from 'LuxKit/Chips/FilterChip'
import LineExternalLinkAltIcon from 'LuxKit/Icons/line/LineExternalLinkAltIcon'

export type ListingDrawerHeaderActionsVertical = 'hotel' | 'experience'

export interface ListingDrawerHeaderActionsProps {
  showBrowseAllAction?: boolean
  browseAllResultsUrl?: string
  vertical: ListingDrawerHeaderActionsVertical
}

function getBrowseAllResultsLabel(
  intl: IntlShape,
  vertical: ListingDrawerHeaderActionsVertical,
): string {
  switch (vertical) {
    case 'hotel':
      return intl.formatMessage({
        id: 'itl8WEctxs1Z0nf23fD3',
        defaultMessage: 'Browse all results',
        description:
          'Button label linking to the full hotel search results page',
      })
    case 'experience':
      return intl.formatMessage({
        id: 'nemeMlkPWyHbg8VU1XwY',
        defaultMessage: 'Browse all results',
        description:
          'Button label linking to the full experience search results page',
      })
    default: {
      const exhaustiveCheck: never = vertical
      return exhaustiveCheck
    }
  }
}

function ListingDrawerHeaderActions({
  showBrowseAllAction = false,
  browseAllResultsUrl,
  vertical,
}: ListingDrawerHeaderActionsProps) {
  const intl = useIntl()

  if (!showBrowseAllAction) {
    return null
  }

  const browseAllResultsLabel = getBrowseAllResultsLabel(intl, vertical)

  return (
    <Group direction="horizontal" gap={8} verticalAlign="center" horizontalAlign="end" wrap="wrap">
      {showBrowseAllAction && (
        <FilterChip
          size="small"
          href={browseAllResultsUrl}
          target="_blank"
          rel="noopener noreferrer"
          endIcon={<LineExternalLinkAltIcon />}
        >
          {browseAllResultsLabel}
        </FilterChip>
      )}
    </Group>
  )
}

export default ListingDrawerHeaderActions
